import React, {Component, ReactNode} from 'react'
import styled from 'styled-components'

interface Props {
    label: string,
    children: ReactNode,
}

interface State {
}

class ColonSeparatedItem extends Component<Props, State> {
    render(): ReactNode {
        return <Row>
            <Label>{this.props.label}：</Label>
            <Value>{this.props.children}</Value>
        </Row>
    }
}

export default ColonSeparatedItem

const Row = styled.div`
  display: flex;
  align-items: flex-start;
`;

const Label = styled.span`
  white-space: nowrap;
`;

const Value = styled.span`
  word-break: break-word;
  overflow-wrap: anywhere;
`;
